import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylio1 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_1: TIdToPageConfigMap = {
  [PageIdStylio1.START_SCREEN_STYLIO_1]: {
    id: PageIdStylio1.START_SCREEN_STYLIO_1,
    hasHeader: true,
  },
  [PageIdStylio1.AGE_STYLIO_1]: {
    id: PageIdStylio1.AGE_STYLIO_1,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylio1.URGE_STYLIO_1]: {
    id: PageIdStylio1.URGE_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylio1.HAIR_COLOR_STYLIO_1]: {
    id: PageIdStylio1.HAIR_COLOR_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.EYES_COLOR_STYLIO_1]: {
    id: PageIdStylio1.EYES_COLOR_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylio1.JEWELRY_STYLIO_1]: {
    id: PageIdStylio1.JEWELRY_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylio1.BODY_SHAPE_STYLIO_1]: {
    id: PageIdStylio1.BODY_SHAPE_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylio1.STYLIO_TO_HELP_STYLIO_1]: {
    id: PageIdStylio1.STYLIO_TO_HELP_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylio1.TALL_STYLIO_1]: {
    id: PageIdStylio1.TALL_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylio1.WEIGHT_STYLIO_1]: {
    id: PageIdStylio1.WEIGHT_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylio1.URGE_2_STYLIO_1]: {
    id: PageIdStylio1.URGE_2_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylio1.SHOPPING_STYLIO_1]: {
    id: PageIdStylio1.SHOPPING_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.STYLE_MOST_MATTERS_STYLIO_1]: {
    id: PageIdStylio1.STYLE_MOST_MATTERS_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.FAVORITE_COLORS_STYLIO_1]: {
    id: PageIdStylio1.FAVORITE_COLORS_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_STYLIO_1]: {
    id: PageIdStylio1.LIKE_OR_DISLIKE_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_11_STYLIO_1]: {
    id: PageIdStylio1.LIKE_OR_DISLIKE_11_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_12_STYLIO_1]: {
    id: PageIdStylio1.LIKE_OR_DISLIKE_12_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_13_STYLIO_1]: {
    id: PageIdStylio1.LIKE_OR_DISLIKE_13_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_14_STYLIO_1]: {
    id: PageIdStylio1.LIKE_OR_DISLIKE_14_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_15_STYLIO_1]: {
    id: PageIdStylio1.LIKE_OR_DISLIKE_15_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_16_STYLIO_1]: {
    id: PageIdStylio1.LIKE_OR_DISLIKE_16_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_17_STYLIO_1]: {
    id: PageIdStylio1.LIKE_OR_DISLIKE_17_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.STYLES_FEEL_LIKE_YOU_STYLIO_1]: {
    id: PageIdStylio1.STYLES_FEEL_LIKE_YOU_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylio1.URGE_4_STYLIO_1]: {
    id: PageIdStylio1.URGE_4_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylio1.BRAND_STYLIO_1]: {
    id: PageIdStylio1.BRAND_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.FIND_NEW_CLOTHES_STYLIO_1]: {
    id: PageIdStylio1.FIND_NEW_CLOTHES_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.NOTHING_TO_WEAR_STYLIO_1]: {
    id: PageIdStylio1.NOTHING_TO_WEAR_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylio1.OLD_CLOTHES_STYLIO_1]: {
    id: PageIdStylio1.OLD_CLOTHES_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylio1.COMBINE_CLOTHES_STYLIO_1]: {
    id: PageIdStylio1.COMBINE_CLOTHES_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.OUTFIT_LOOK_STYLIO_1]: {
    id: PageIdStylio1.OUTFIT_LOOK_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.OPTIMIZE_BUDGET_STYLIO_1]: {
    id: PageIdStylio1.OPTIMIZE_BUDGET_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.EVERYDAY_LIFESTYLE_STYLIO_1]: {
    id: PageIdStylio1.EVERYDAY_LIFESTYLE_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.CLIMAT_STYLIO_1]: {
    id: PageIdStylio1.CLIMAT_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.URGE_3_STYLIO_1]: {
    id: PageIdStylio1.URGE_3_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylio1.PREPARE_FLOW_STYLIO_1]: {
    id: PageIdStylio1.PREPARE_FLOW_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylio1.EMAIL_STYLIO_1]: {
    id: PageIdStylio1.EMAIL_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylio1.EMAIL_CONSENT_STYLIO_1]: {
    id: PageIdStylio1.EMAIL_CONSENT_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylio1.SUBSCRIPTIONS_STYLIO_1]: {
    id: PageIdStylio1.SUBSCRIPTIONS_STYLIO_1,
    hasHeader: true,
  },
  [PageIdStylio1.CANCEL_OFFER_STYLIO_1]: {
    id: PageIdStylio1.CANCEL_OFFER_STYLIO_1,
    hasHeader: true,
  },
  [PageIdStylio1.SUB_UPSELL_STYLIO_1]: {
    id: PageIdStylio1.SUB_UPSELL_STYLIO_1,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylio1.UPSELL_STYLIO_1]: {
    id: PageIdStylio1.UPSELL_STYLIO_1,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylio1.NAME_STYLIO_1]: {
    id: PageIdStylio1.NAME_STYLIO_1,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylio1.LAST_CHANCE_OFFER_STYLIO_1]: {
    id: PageIdStylio1.LAST_CHANCE_OFFER_STYLIO_1,
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_18_STYLIO_1]: {
    id: PageIdStylio1.LIKE_OR_DISLIKE_18_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.LIKE_OR_DISLIKE_19_STYLIO_1]: {
    id: PageIdStylio1.LIKE_OR_DISLIKE_19_STYLIO_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylio1.DOWNLOAD_STYLIO_1]: {
    id: PageIdStylio1.DOWNLOAD_STYLIO_1,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
